import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Text, Input, Button, Tooltip } from '@bufferapp/ui';

import { uploadAltTextChanged } from '~/uploads/state/slice';
import CharacterCount from '~/composer/composer/components/CharacterCount';
import { Upload } from '../../entities/Upload';

import {
  Description,
  DescriptionInput,
  DescriptionLabel,
  UnknownIconStyled,
  ButtonWrapper,
  CountWrapper,
  CountBox,
} from './styles';

const altExplanation = (
  <>
    <p>
      A description, sometimes called alt-text, makes your images and videos
      accessible to people unable to see them.
    </p>
    <p>The text will also appear in place of the image if it fails to load.</p>
    <p>
      Good descriptions are descriptive and specific. Add context to help people
      create a precise picture of your image.
    </p>
  </>
);

const MAX_ALT_LENGTH = 125;

const ImageDescription = ({
  upload,
  onClose,
}: {
  upload: Upload;
  onClose: () => void;
}) => {
  const dispatch = useDispatch();
  const [altText, setAltText] = useState('');

  useEffect(() => {
    if (upload.alt) {
      setAltText(upload.alt);
    }
  }, [upload.alt]);

  const onSaveDescription = () => {
    dispatch(uploadAltTextChanged({ id: upload.id, altText }));
    onClose();
  };

  return (
    <Description>
      <DescriptionInput>
        <DescriptionLabel>
          <Text type="label">Add a Description</Text>
          <Tooltip customLabel={altExplanation} position="top">
            <UnknownIconStyled size="small" />
          </Tooltip>
        </DescriptionLabel>
        <Input
          type="text"
          name="description"
          placeholder="Add a description to your photos so they're accessible to people unable to see them."
          onChange={(e) => setAltText(e.target.value)}
          value={altText}
        />
      </DescriptionInput>
      <CountWrapper>
        <CountBox>
          <CharacterCount
            count={altText?.length || 0}
            maxCount={MAX_ALT_LENGTH}
          />
        </CountBox>
      </CountWrapper>
      <ButtonWrapper>
        <Button
          type="primary"
          label="Save"
          onClick={onSaveDescription}
          disabled={altText.length > MAX_ALT_LENGTH}
        />
      </ButtonWrapper>
    </Description>
  );
};

ImageDescription.propTypes = {};

export default ImageDescription;
